import Vue from "vue"

Vue.filter("shortify", function (text, maxLength = 20, tail = "…") {
    return text.length > maxLength ? text.substr(0, maxLength) + tail : text
})
